import React, { useContext, useState } from 'react';
// import { Acl } from 'modules/common/components/Acl';
// import { getJson } from 'session';
import { setItem } from 'api/actions';
import { get, groupBy } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import CalculationModal from './CalculationModal';
import FeeInformation from '../components/FeeInformation';
// import ViewSOA from '../components/ViewSOA';
import {
  INITIAL_COMPUTATION,
  SELECTED_CALCULATION,
  // FINAL_COMPUTATION,
  // ITEM,
} from '../constant';
// import { finalComputation, getItem, generateSOA } from '../actions';

function InitialComputationModal({ permitId, selectedTab }) {
  const setModal = useContext(ModalContext);
  const dispatch = useDispatch();
  const [tab, setStab] = useState(selectedTab);
  const data = useSelector(
    ({ api }) => get(api, `${INITIAL_COMPUTATION}.list`) || []
  );
  // const isFinalComputing = useSelector(
  //   ({ api }) => api.loading.indexOf(FINAL_COMPUTATION) > -1
  // );
  // const items = useSelector(({ api }) => get(api, `${ITEM}.item`) || {});
  // const permissions = getJson('permissions');

  const formatedData = groupBy(
    data.map(item => ({
      ...get(item, 'attributes'),
      id: get(item, 'id'),
    })),
    'group'
  );

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const viewCalculationModal = item => e => {
    e.preventDefault();
    dispatch(setItem(SELECTED_CALCULATION, get(item, 'id')));
    setModal({
      isOpen: true,
      content: (
        <CalculationModal
          permitId={+permitId}
          parentData={data}
          data={item}
          selectedTab={tab}
        />
      ),
      title: 'Calculation',
      modalSize: 'modal-lg',
    });
  };

  const onSelectTab = value => {
    setStab(value);
  };

  // const onHandleFinalComputation = e => {
  //   e.preventDefault();
  //   dispatch(
  //     finalComputation(permitId, {}, () => {
  //       generateSOA(permitId);
  //       setModal({
  //         isOpen: true,
  //         content: <ViewSOA data={items} />,
  //         title: 'View e-SOA',
  //         modalSize: 'modal-xl',
  //       });
  //       dispatch(getItem(permitId));
  //     })
  //   );
  // };

  return (
    <Modal.Body>
      <div className="card-content-listing p-0">
        <Tabs onSelect={onSelectTab} selectedIndex={tab || 0}>
          <TabList>
            {Object.keys(formatedData).map(label => {
              return <Tab>{label}</Tab>;
            })}
          </TabList>
          {Object.keys(formatedData).map(label => {
            return (
              <TabPanel>
                <div
                  className="p-1"
                  style={{ maxHeight: 600, overflow: 'auto' }}
                >
                  {get(formatedData, `${label}`, []).map(item => {
                    return (
                      <div
                        className={`${
                          get(formatedData, `${label}`, []).length > 1
                            ? `border rounded`
                            : ``
                        } p-1 mb-1 position-relative`}
                      >
                        <div
                          className="text-right"
                          style={{ top: 3, right: 3, zIndex: 1000 }}
                        >
                          <button
                            onClick={viewCalculationModal(item)}
                            type="button"
                            className="btn btn-link"
                          >
                            <i className="fas fa-eye" /> View Calculations
                          </button>
                        </div>
                        <div>
                          <FeeInformation data={item} />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </TabPanel>
            );
          })}
        </Tabs>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-center">
            {/* {Acl(permissions, ['E2E BPLS FINAL COMPUTATION']) && (
              <button
                disabled={isFinalComputing}
                type="button"
                onClick={onHandleFinalComputation}
                className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary    "
              >
                <span className="font-weight-bold">
                  {isFinalComputing ? (
                    <div>
                      <i className="fa fa-spin fa-spinner" />
                    </div>
                  ) : (
                    `Final Computation`
                  )}
                </span>
              </button>
            )} */}
            &nbsp;
            <button
              type="button"
              onClick={closeModal}
              className="mt-3 btn btn-dark "
            >
              <span className="font-weight-bold">Close</span>
            </button>
          </div>
        </div>
      </div>
    </Modal.Body>
  );
}

InitialComputationModal.propTypes = {
  permitId: PropTypes.number.isRequired,
  selectedTab: PropTypes.number.isRequired,
};

export default InitialComputationModal;
